import { render, staticRenderFns } from "./BaseCard.vue?vue&type=template&id=524ddc6b"
import script from "./BaseCard.vue?vue&type=script&lang=js"
export * from "./BaseCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports